import styled from 'styled-components';

const withChart =
  '[col-icon] min-content [col-name] min-content [col-percent] auto [col-count] min-content';
const withoutChart = '[col-name] auto [col-count] min-content';

export const TableWrapper = styled.div<{ $hasMeterChart?: boolean }>`
  display: grid;
  grid-template-columns: ${({ $hasMeterChart }) => ($hasMeterChart ? withChart : withoutChart)};
  align-items: stretch;
  font-family: 'Sofia Pro', system-ui, -apple-system, BlinkMacSystemFont, 'Avenir Next', Avenir,
    'Segoe UI', 'Lucida Grande', 'Helvetica Neue', Helvetica, 'Fira Sans', Roboto, Noto,
    'Droid Sans', Cantarell, Oxygen, Ubuntu, 'Franklin Gothic Medium', 'Century Gothic',
    'Liberation Sans', sans-serif;
  background-color: #fff;
  margin: 0 -${({ theme }) => theme.spacing.values.base} 0 -${({ theme }) =>
    theme.spacing.values.plusHalf};
`;
